import React from "react"
import type { StepConfig } from "./types"
import { INPUT_CLASS } from "./constants"

interface ForwardConfigProps {
  config: StepConfig
  disabled?: boolean
  onChange: (updates: Partial<StepConfig>) => void
}

export function ForwardConfig({ config, disabled = false, onChange }: ForwardConfigProps) {
  return (
    <>
      <div className="space-y-1">
        <label className="block text-xs font-medium text-gray-700">
          Forward URL
        </label>
        <input
          type="text"
          value={config.url || ""}
          disabled={disabled}
          onChange={(e) => onChange({ url: e.target.value })}
          className={INPUT_CLASS}
          placeholder="https://your-server.com/webhook"
        />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700">
            Timeout (seconds)
          </label>
          <input
            type="number"
            value={config.timeout_seconds ?? 30}
            disabled={disabled}
            onChange={(e) =>
              onChange({ timeout_seconds: parseInt(e.target.value) || 30 })
            }
            min={1}
            max={300}
            className={INPUT_CLASS}
          />
        </div>
        <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700">
            Retry Count
          </label>
          <input
            type="number"
            value={config.retry_count ?? 0}
            disabled={disabled}
            onChange={(e) =>
              onChange({ retry_count: parseInt(e.target.value) || 0 })
            }
            min={0}
            max={5}
            className={INPUT_CLASS}
          />
        </div>
        <div className="space-y-1 flex items-end gap-2 pb-1">
          <div className="flex items-center gap-1.5">
            <input
              type="checkbox"
              checked={!!config.append_original_path}
              disabled={disabled}
              onChange={(e) =>
                onChange({ append_original_path: e.target.checked })
              }
              className="h-3.5 w-3.5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label className="text-xs text-gray-600">Append path</label>
          </div>
          <div className="flex items-center gap-1.5">
            <input
              type="checkbox"
              checked={!!config.append_original_query}
              disabled={disabled}
              onChange={(e) =>
                onChange({ append_original_query: e.target.checked })
              }
              className="h-3.5 w-3.5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label className="text-xs text-gray-600">Append query</label>
          </div>
        </div>
      </div>
    </>
  )
}
